import { ElementType, ReactNode } from 'react'
import { Box } from '@mui/material'

export default function ScreenReaderOnly({
    children,
    component
}: {
    children: ReactNode
    component?: ElementType<any> | undefined
}) {
    return (
        <Box
            component={component}
            sx={{
                position: 'absolute',
                width: '1px',
                height: '1px',
                padding: 0,
                margin: '-1px',
                overflow: 'hidden',
                clip: 'rect(0, 0, 0, 0)',
                whiteSpace: 'nowrap',
                borderWidth: 0
            }}
        >
            {children}
        </Box>
    )
}
